import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
// import { useAnalytics } from '@keiko-app/react-google-analytics'
import { useAppAnalytics } from '@/services/analytics'

const PageviewAnalyticsWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const location = useLocation()
  const { trackEvent, events } = useAppAnalytics()

  useEffect(() => {
    // Track standard page view via library (optional, depending on if we want duplicate generic page_views)
    // tracker.trackPageView({}) 
    
    // Track custom screen_viewed event with standard properties
    trackEvent(events.SCREEN_VIEWED, {
      screen_name: location.pathname,
    })
  }, [location, trackEvent, events.SCREEN_VIEWED]) // events is constant object

  return children
}

export default PageviewAnalyticsWrapper
